import '@styles/components/appHeader.less';
import { setShowMenuMask } from '@store/appSlice';
import { useAppDispatch } from '@hooks/reduxHooks';

const AppHeader = () => {
  const dispatch = useAppDispatch();

  /**
   * 打开菜单遮罩层
   */
  const openMenuMask = () => {
    dispatch(setShowMenuMask(true));
  };

  return (
    <div className={'app-header'}>
      <img className={'header-logo'} src={require('@images/common/company.jpg').default} alt="" />

      <img
        className={'menu-icon'}
        src={require('@images/common/menuIcon.png').default}
        alt=""
        onClick={openMenuMask}
      />

      {/* {userInfo.jwt ? ( */}
      {/*   <Popover placement={'bottomLeft'} content={popoverContentJSX}> */}
      {/*     <img */}
      {/*       className={'user-head'} */}
      {/*       style={{ borderRadius: '50%', height: 25 }} */}
      {/*       src={userInfo.avatar || require('@images/common/defaultHead.png').default} */}
      {/*       alt="" */}
      {/*     /> */}
      {/*   </Popover> */}
      {/* ) : ( */}
      {/*   <img */}
      {/*     className={'user-head'} */}
      {/*     src={require('@images/common/userHead1.png').default} */}
      {/*     onClick={() => { */}
      {/*       history.push('/login'); */}
      {/*     }} */}
      {/*     alt="" */}
      {/*   /> */}
      {/* )} */}
    </div>
  );
};

export default AppHeader;
